function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["after", "afterProps", "allowCustomValue", "allowOptionsWrapping", "before", "beforeProps", "bodyProps", "className", "clearAfterCustomValue", "closeOnClickAway", "comboboxDivProps", "comboboxTextareaProps", "disabled", "disabledOptions", "duplicate", "editable", "ellipsis", "error", "errorProps", "expandOnHover", "headerProps", "helpText", "helpTextId", "helpTextProps", "iconButtonProps", "id", "initialExpanded", "initialSelectedIndex", "inlineAlertId", "innerProps", "insidePopout", "labelId", "labelPosition", "labelProps", "labels", "leftIcon", "leftIconProps", "listboxProps", "loading", "locale", "look", "onExpanded", "onSelection", "optionProps", "options", "parentScrolls", "placement", "possiblePlacements", "readOnly", "required", "reset", "search", "searchDebounce", "searchFilter", "searchMinLength", "showEmptyOption", "showIconButton", "showLabel", "showLoadingOption", "showPlaceholderOption", "tagger", "toggleExpanded", "transition", "transitionDelay", "transitionDuration", "virtualized"],
  _excluded2 = ["ref", "style"],
  _excluded3 = ["allowCustomValue", "allowOptionsWrapping", "clearAfterCustomValue", "closeOnClickAway", "editable", "labelPosition", "look", "placement", "search", "searchDebounce", "searchMinLength", "showEmptyOption", "showIconButton", "showLabel", "showLoadingOption", "showPlaceholderOption", "transition", "transitionDelay", "transitionDuration"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DEFAULT_ISO_LANGUAGE_REGION } from '@brandfolder/utilities';
import classnames from 'classnames';
import React, { useRef, useState, useEffect, useContext } from 'react';
import { useLayer } from 'react-laag';
import { Transition } from 'react-transition-group';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../../../enums/colors.js";
import { ComboboxPlacements } from "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import { Keysets } from "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import { Transitions } from "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useClickOutside } from "../../../../hooks/use-click-outside.js";
import { useDebounce } from "../../../../hooks/use-debounce.js";
import { generateKey } from "../../../../utilities/key.js";
import "../../../../utilities/color.js";
import { getContainer } from "../../../../utilities/container.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import { useHover } from "../../../../hooks/use-hover.js";
import { usePrefersReducedMotion } from "../../../../hooks/use-prefers-reduced-motion.js";
import { preventKeyboardScrollingKeyboardEvent } from "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import { borderRadiusLarge } from "../../../../themes/borders.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import { baseInputStyle, getInputBorderRadius, getInputPadding, getInputTheme, getInputHoveredBorderColor, getInputFocusedBorderColor, getInputPlaceholderColor } from "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { transitionFadeIn } from "../../../../styles/transitions/fade-in.js";
import { transitionFadeInSlide } from "../../../../styles/transitions/fade-in-slide.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import { IconButton } from "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import "../../../internal/list/standard-list/standard-list.js";
import { StandardListbox } from "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import { TextfieldBody } from "../../../internal/textfield/textfield-body.js";
import { TextfieldHeader } from "../../../internal/textfield/textfield-header.js";
import { TextfieldIcon, TextfieldIconTypes } from "../../../internal/textfield/textfield-icon.js";
import { TextfieldInner } from "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseCombobox } from "../base-combobox/base-combobox.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var DEFAULT_SELECT_FILTER = function DEFAULT_SELECT_FILTER(options) {
  var _options$option$searc;
  return !!((_options$option$searc = options.option.search) !== null && _options$option$searc !== void 0 && _options$option$searc.toLocaleLowerCase(options.locale).startsWith(options.value.toLocaleLowerCase(options.locale)));
};
var DEFAULT_EDITABLE_FILTER = function DEFAULT_EDITABLE_FILTER(options) {
  var _options$option$searc2;
  return !!((_options$option$searc2 = options.option.search) !== null && _options$option$searc2 !== void 0 && _options$option$searc2.toLocaleLowerCase(options.locale).includes(options.value.toLocaleLowerCase(options.locale)));
};
var BaseStandardCombobox = function BaseStandardCombobox(props) {
  var _classnames, _listboxOptions$selec, _options$;
  var after = props.after,
    afterProps = props.afterProps,
    allowCustomValue = props.allowCustomValue,
    allowOptionsWrapping = props.allowOptionsWrapping,
    before = props.before,
    beforeProps = props.beforeProps,
    bodyProps = props.bodyProps,
    className = props.className,
    clearAfterCustomValue = props.clearAfterCustomValue,
    closeOnClickAway = props.closeOnClickAway,
    comboboxDivProps = props.comboboxDivProps,
    comboboxTextareaProps = props.comboboxTextareaProps,
    disabled = props.disabled,
    disabledOptions = props.disabledOptions,
    duplicate = props.duplicate,
    editable = props.editable,
    ellipsis = props.ellipsis,
    error = props.error,
    errorProps = props.errorProps,
    expandOnHover = props.expandOnHover,
    headerProps = props.headerProps,
    helpText = props.helpText,
    helpTextId = props.helpTextId,
    helpTextProps = props.helpTextProps,
    iconButtonProps = props.iconButtonProps,
    id = props.id,
    initialExpanded = props.initialExpanded,
    initialSelectedIndex = props.initialSelectedIndex,
    inlineAlertId = props.inlineAlertId,
    innerProps = props.innerProps,
    insidePopout = props.insidePopout,
    labelId = props.labelId,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    labels = props.labels,
    leftIcon = props.leftIcon,
    leftIconProps = props.leftIconProps,
    listboxProps = props.listboxProps,
    loading = props.loading,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? DEFAULT_ISO_LANGUAGE_REGION : _props$locale,
    look = props.look,
    onExpanded = props.onExpanded,
    onSelection = props.onSelection,
    optionProps = props.optionProps,
    options = props.options,
    parentScrolls = props.parentScrolls,
    placement = props.placement,
    _props$possiblePlacem = props.possiblePlacements,
    possiblePlacements = _props$possiblePlacem === void 0 ? [ComboboxPlacements.BottomStart, ComboboxPlacements.TopStart] : _props$possiblePlacem,
    readOnly = props.readOnly,
    required = props.required,
    reset = props.reset,
    search = props.search,
    searchDebounce = props.searchDebounce,
    searchFilter = props.searchFilter,
    searchMinLength = props.searchMinLength,
    showEmptyOption = props.showEmptyOption,
    showIconButton = props.showIconButton,
    showLabel = props.showLabel,
    showLoadingOption = props.showLoadingOption,
    showPlaceholderOption = props.showPlaceholderOption,
    tagger = props.tagger,
    toggleExpanded = props.toggleExpanded,
    transition = props.transition,
    transitionDelay = props.transitionDelay,
    transitionDuration = props.transitionDuration,
    virtualized = props.virtualized,
    otherProps = _objectWithoutProperties(props, _excluded);
  var emptyLabel = labels.emptyLabel,
    iconButtonLabel = labels.iconButtonLabel,
    label = labels.label,
    listboxLabel = labels.listboxLabel,
    loaderLabel = labels.loaderLabel,
    requiredLabel = labels.requiredLabel;
  var comboboxBodyId = "".concat(id, "-combobox-body");
  var helpId = helpTextId || "".concat(id, "-help-text");
  var alertId = inlineAlertId || "".concat(id, "-inline-alert");
  var labId = labelId || "".concat(id, "-label");
  var listboxId = "".concat(id, "-listbox");
  var comboboxId = "".concat(id, "-combobox");
  var wrapperId = "".concat(id, "-wrapper");
  var hasInitialSelectedIndex = initialSelectedIndex !== undefined && initialSelectedIndex > -1;
  var initialIndex = hasInitialSelectedIndex ? initialSelectedIndex : editable ? undefined : 0;
  var hasInitialIndex = initialIndex !== undefined;
  var hasAfter = !!after;
  var hasBefore = !!before;
  var hasCustomEditable = allowCustomValue && editable;
  var hasError = !!error;
  var hasHelpText = !!helpText;
  var hasLeftIcon = !!leftIcon;
  var hasOptions = options.length > 0;
  var hasRequired = required;
  var isLoading = loading === true && !!loaderLabel;
  var hasLoadingOption = editable && showLoadingOption;
  var loadingDisabled = !editable && isLoading || editable && !hasLoadingOption && isLoading;
  var searchable = editable && search;
  var notSearchable = editable && !search;
  var prefersReducedMotion = usePrefersReducedMotion();
  var wrapperRef = useRef(null);
  var _useClickOutside = useClickOutside({
      ref: wrapperRef
    }),
    clickedOutside = _useClickOutside.clickedOutside;
  var divRef = useRef(null);
  var nodeRef = useRef(null);
  var textareaRef = useRef(null);
  var getDisabledOptions = function getDisabledOptions(opts) {
    if (!disabledOptions || opts.length === 0) {
      return opts;
    }
    return opts.map(function (option) {
      var opt = disabledOptions.find(function (disabledOption) {
        return option.key === disabledOption.key || option.key === disabledOption.value;
      });
      option.disabled = !!opt;
      return option;
    });
  };
  var getListboxOptions = function getListboxOptions(opts) {
    var disabledOptions = getDisabledOptions(opts);
    var firstOption = disabledOptions[0];
    if (!showPlaceholderOption && !!(firstOption !== null && firstOption !== void 0 && firstOption.placeholder)) return disabledOptions.splice(1);
    return _toConsumableArray(disabledOptions);
  };
  var _useState = useState(initialExpanded || false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    selected = _useState6[0],
    setSelected = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    touched = _useState8[0],
    setTouched = _useState8[1];
  var _useState9 = useState(getListboxOptions(options)),
    _useState10 = _slicedToArray(_useState9, 2),
    listboxOptions = _useState10[0],
    setListboxOptions = _useState10[1];
  var hasListboxOptions = listboxOptions.length > 0;
  var hasEnabledListboxOptions = listboxOptions.some(function (option) {
    return !option.disabled;
  });
  var hasFetchedOptions = hasListboxOptions && !notSearchable;
  var _useState11 = useState(initialIndex),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedIndex = _useState12[0],
    setSelectedIndex = _useState12[1];
  var hasSelectedIndex = selectedIndex !== undefined;
  var hasInitialOption = hasListboxOptions && hasInitialIndex;
  var initialOption = hasInitialOption ? listboxOptions[initialIndex] : null;
  var _useState13 = useState(initialOption),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedOption = _useState14[0],
    setSelectedOption = _useState14[1];
  var initialValue = editable && initialOption ? initialOption.value.toString().trim() : '';
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    value = _useState16[0],
    setValue = _useState16[1];
  var valueDebounced = useDebounce(value, searchDebounce);
  var canShowEmpty = showEmptyOption && !!emptyLabel;
  var hasEmptyOption = searchable ? canShowEmpty && !isLoading && touched && !hasListboxOptions && valueDebounced : canShowEmpty && !isLoading && touched && !hasOptions && valueDebounced;
  useEffect(function () {
    if (editable && initialValue && !selected && !touched) {
      setValue(initialValue);
    }
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (notSearchable && !selected && touched && !value) {
      toggleExpand(true);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (!editable) {
      /**
      * This reproduces when focused on a `<select>` and typing.
      *
      * Opens the listbox and moves visual focus
      * to the first option that matches the typed character.
      *
      * If multiple keys are typed in quick succession,
      * visual focus moves to the first option that matches the full string.
      */
      if (valueDebounced) {
        var optionIndex = options.findIndex(function (option) {
          return searchFilter ? searchFilter({
            option: option,
            value: valueDebounced,
            locale: locale
          }) : DEFAULT_SELECT_FILTER({
            option: option,
            value: valueDebounced,
            locale: locale
          });
        });
        if (optionIndex > -1) {
          var option = listboxOptions[optionIndex];
          toggleExpand(true);
          if (!option.disabled) {
            setSelectedIndex(optionIndex);
          }
        }
        setValue('');
      }
    } else if (searchable && touched) {
      /**
      * Moves visual focus to the textbox.
      *
      * Types the character in the textbox.
      *
      * Options in the listbox are filtered based on characters in the textbox.
      */
      if (valueDebounced && valueDebounced.length > searchMinLength && !selected) {
        var searchedOptions = options.filter(function (option) {
          return searchFilter ? searchFilter({
            option: option,
            value: valueDebounced,
            locale: locale
          }) : DEFAULT_EDITABLE_FILTER({
            option: option,
            value: valueDebounced,
            locale: locale
          });
        });
        setListboxOptions(searchedOptions);
      } else {
        setListboxOptions(options);
      }
      if (searchMinLength === 0 || valueDebounced.length > searchMinLength) {
        toggleExpand(true);
      }
      setSelected(false);
      setSelectedIndex(undefined);
    } else if (!notSearchable && !selected && touched && valueDebounced) {
      toggleExpand(true);
      setSelected(false);
      setSelectedIndex(undefined);
    }
  }, [valueDebounced]); // eslint-disable-line react-hooks/exhaustive-deps
  /**
  * IMPORTANT: `react-laag` also has a `useHover` hook, but it doesn't expose
  * a `setHovered` to manually turn hovering off when we select an option.
  */
  var _useHover = useHover(),
    hoverProps = _useHover.hoverProps,
    hovered = _useHover.hovered,
    setHovered = _useHover.setHovered;
  useEffect(function () {
    if (expandOnHover) {
      setExpanded(hovered);
    }
  }, [expandOnHover, hovered]); // eslint-disable-line react-hooks/exhaustive-deps
  var canExpand = !disabled && !loadingDisabled && !readOnly;
  var isExpanded = canExpand && expanded;
  var toggleExpand = function toggleExpand(toggle) {
    if (canExpand && toggle !== undefined) {
      setExpanded(toggle);
      if (toggle === false) {
        setHovered(false);
      }
    } else if (canExpand) {
      setExpanded(function (previousExpanded) {
        return !previousExpanded;
      });
      if (!expanded === false) {
        setHovered(false);
      }
    }
  };
  var resetSelected = function resetSelected() {
    setSelectedOption(initialOption);
    setSelectedIndex(initialIndex);
  };
  useEffect(function () {
    if (reset) {
      setListboxOptions(getListboxOptions(options));
      toggleExpand(false);
      setTouched(false);
      setValue('');
      resetSelected();
    }
  }, [reset]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (hasLoadingOption && isLoading && touched) {
      toggleExpand(true);
    }
  }, [hasLoadingOption, isLoading, touched]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (canExpand && toggleExpanded !== undefined) {
      toggleExpand(toggleExpanded);
    }
  }, [toggleExpanded]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (focused) {
      // prevents window jumping when home and enter are pressed and ONLY when combobox is focused
      var listener = function listener(e) {
        return preventKeyboardScrollingKeyboardEvent(e, Keysets.ComboboxInput);
      };
      window.addEventListener('keydown', listener, false);
      return function () {
        return window.removeEventListener('keydown', listener);
      };
    }
    return;
  }, [focused]);
  useEffect(function () {
    if (onExpanded) {
      onExpanded(isExpanded);
    }
  }, [isExpanded]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (disabledOptions && !reset) {
      setListboxOptions(getListboxOptions(listboxOptions));
    }
  }, [disabledOptions]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    setListboxOptions(getListboxOptions(options));
  }, [options]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (insidePopout && clickedOutside && closeOnClickAway) {
      toggleExpand(false);
    }
  }, [clickedOutside]); // eslint-disable-line react-hooks/exhaustive-deps
  var resetCombobox = function resetCombobox() {
    toggleExpand(false);
    setHovered(false);
    setTouched(false);
    focusCombobox();
    setTimeout(function () {
      setSelected(false);
    }, 50);
  };
  /**
  * Sets the value to the content of the focused option in the listbox.
  * Closes the listbox.
  * Sets visual focus on the combobox.
  */
  var onSelected = function onSelected(index) {
    setSelected(true);
    var option = index === undefined ? null : listboxOptions[index];
    if (notSearchable || hasCustomEditable) {
      resetSelected();
    } else {
      setSelectedOption(option);
      setSelectedIndex(index);
    }
    if (option) {
      onSelection(option, index, option.value);
    }
    if (clearAfterCustomValue && editable || !editable) {
      setValue('');
    } else if (option) {
      setValue(option.value.toString().trim());
    }
    resetCombobox();
  };
  var onManualSelection = function onManualSelection() {
    if (!duplicate) {
      setSelected(true);
      resetSelected();
      onSelection(null, undefined, value);
      if (clearAfterCustomValue) {
        setValue('');
      }
      resetCombobox();
    }
  };
  var focusCombobox = function focusCombobox() {
    if (!editable && divRef.current) {
      divRef.current.focus({
        preventScroll: true
      });
    } else if (textareaRef.current) {
      textareaRef.current.focus({
        preventScroll: true
      });
    }
  };
  var getFirstEnabledOptionIndex = function getFirstEnabledOptionIndex() {
    return listboxOptions.findIndex(function (option) {
      return !option.disabled;
    });
  };
  var getLastEnabledOptionIndex = function getLastEnabledOptionIndex() {
    // iterate backwards through the options and break when we find one that's not disabled
    // (neither lastIndexOf or reverse().findIndex give us correct index)
    for (var i = listboxOptions.length - 1; i >= 0; i--) {
      if (!listboxOptions[i].disabled) return i;
    }
    return undefined;
  };
  var getFirstOption = function getFirstOption() {
    if (hasListboxOptions && hasEnabledListboxOptions) {
      return getFirstEnabledOptionIndex();
    }
    return;
  };
  var getLastOption = function getLastOption() {
    if (hasListboxOptions && hasEnabledListboxOptions) {
      return getLastEnabledOptionIndex();
    }
    return;
  };
  var getNextOption = function getNextOption(index) {
    // if no listboxOptions or all listboxOptions are disabled, do nothing
    if (!hasListboxOptions || !hasEnabledListboxOptions) return;
    var nextIndex = index + 1;
    var lastEnabledIndex = getLastEnabledOptionIndex();
    var atLast = index === lastEnabledIndex;
    var nextOption = listboxOptions[atLast ? lastEnabledIndex : nextIndex];
    // if we've selected the last enabled option and can wrap
    // go to the first enabled option
    if (atLast && allowOptionsWrapping) {
      return getFirstEnabledOptionIndex();
    }
    // if the next option isn't disabled and we're not at the last enabled option
    // select that next option
    if (!nextOption.disabled && !atLast) {
      return nextIndex;
    }
    // otherwise we need to recursively keep trying to find
    // another next option that isn't disabled
    return getNextOption(nextIndex);
  };
  var getPreviousOption = function getPreviousOption(index) {
    // if no listboxOptions or all listboxOptions are disabled, do nothing
    if (!hasListboxOptions || !hasEnabledListboxOptions) return;
    var previousIndex = index - 1;
    var firstEnabledIndex = getFirstEnabledOptionIndex();
    var atFirst = index === firstEnabledIndex;
    var previousOption = listboxOptions[atFirst ? firstEnabledIndex : previousIndex];
    // if we've selected the first enabled option and can wrap
    // go to the last enabled option
    if (atFirst && allowOptionsWrapping) {
      return getLastEnabledOptionIndex();
    }
    // if the previous option isn't disabled and we're not at the first enabled option
    // select that previous option
    if (!previousOption.disabled && !atFirst) {
      return previousIndex;
    }
    // otherwise we need to recursively keep trying to find
    // another previous option that isn't disabled
    return getPreviousOption(previousIndex);
  };
  var moveInputCursor = function moveInputCursor(move) {
    if (textareaRef.current) {
      var offset = move === 'end' ? value.length : 0;
      textareaRef.current.setSelectionRange(offset, offset);
    }
  };
  var onOutsideClick = function onOutsideClick() {
    if (closeOnClickAway) toggleExpand(false);
  };
  var _useLayer = useLayer({
      auto: true,
      container: getContainer(comboboxBodyId),
      containerOffset: 5,
      isOpen: isExpanded,
      placement: placement,
      possiblePlacements: possiblePlacements,
      onOutsideClick: onOutsideClick,
      overflowContainer: true,
      snap: true,
      triggerOffset: 10
    }),
    layerProps = _useLayer.layerProps,
    layerSide = _useLayer.layerSide,
    renderLayer = _useLayer.renderLayer,
    triggerProps = _useLayer.triggerProps;
  /**
  * IMPORTANT: The `react-laag` `style` prop is only used if `parentScrolls` prop is `true`.
  */
  var ref = layerProps.ref,
    style = layerProps.style,
    otherLayerProps = _objectWithoutProperties(layerProps, _excluded2);
  /**
  * Setting delay and duration to zero will close the listbox immediately without animating out
  */
  var overrideDuration = selected && tagger;
  var delay = overrideDuration ? 0 : transitionDelay;
  var duration = overrideDuration ? 0 : transitionDuration;
  var timeout = delay > 0 ? delay + duration : duration;
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-combobox__standard': true,
      'bf-combobox__standard--after': hasAfter,
      'bf-combobox__standard--before': hasBefore,
      'bf-combobox__standard--disabled': disabled,
      'bf-combobox__standard--error': hasError,
      'bf-combobox__standard--expanded': isExpanded,
      'bf-combobox__standard--editable': editable,
      'bf-combobox__standard--empty': hasEmptyOption,
      'bf-combobox__standard__focused': focused,
      'bf-combobox__standard--help-text': hasHelpText,
      'bf-combobox__standard--hovered': hovered,
      'bf-combobox__standard--label-hidden': !showLabel
    }, _defineProperty(_classnames, "bf-combobox__standard--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, 'bf-combobox__standard--loading', isLoading), _defineProperty(_classnames, "bf-combobox__standard--locale-".concat(locale), locale), _defineProperty(_classnames, "bf-combobox__standard--look-".concat(look), look), _defineProperty(_classnames, "bf-combobox__standard--position-".concat(layerSide), layerSide), _defineProperty(_classnames, 'bf-combobox__standard--readonly', readOnly), _defineProperty(_classnames, 'bf-combobox__standard--required', hasRequired), _defineProperty(_classnames, "bf-combobox__standard--transition-".concat(transition), transition), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    id: wrapperId,
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(TextfieldHeader, _extends({}, headerProps, {
    className: classnames(_defineProperty({
      'bf-combobox__header': true
    }, "".concat(headerProps === null || headerProps === void 0 ? void 0 : headerProps.className), !!(headerProps !== null && headerProps !== void 0 && headerProps.className))),
    error: error,
    errorProps: errorProps,
    hidden: tagger,
    htmlFor: comboboxId,
    inlineAlertId: alertId,
    label: label,
    labelId: labId,
    labelPosition: labelPosition,
    labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
      onClick: function onClick() {
        focusCombobox();
        toggleExpand(true);
      }
    }),
    required: required,
    requiredLabel: requiredLabel,
    showLabel: showLabel
  })), /*#__PURE__*/React.createElement(TextfieldBody, _extends({}, bodyProps, triggerProps, hoverProps, {
    after: after,
    afterProps: afterProps,
    before: before,
    beforeProps: beforeProps,
    className: classnames(_defineProperty({
      'bf-combobox__body': true
    }, "".concat(bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.className), !!(bodyProps !== null && bodyProps !== void 0 && bodyProps.className))),
    "data-testid": comboboxBodyId,
    disabled: disabled,
    error: error,
    errorProps: errorProps,
    helpText: helpText,
    helpTextId: helpId,
    helpTextProps: helpTextProps,
    hidden: tagger,
    id: comboboxBodyId,
    inlineAlertId: alertId,
    labelPosition: labelPosition,
    look: look
  }), /*#__PURE__*/React.createElement(TextfieldInner, _extends({}, innerProps, {
    className: classnames(_defineProperty({
      'bf-combobox__inner': true
    }, "".concat(innerProps === null || innerProps === void 0 ? void 0 : innerProps.className), !!(innerProps !== null && innerProps !== void 0 && innerProps.className)))
  }), hasLeftIcon && /*#__PURE__*/React.createElement(TextfieldIcon, _extends({}, leftIconProps, {
    className: classnames(_defineProperty({
      'bf-combobox__icon': true,
      'bf-combobox__left-icon': true
    }, "".concat(leftIconProps === null || leftIconProps === void 0 ? void 0 : leftIconProps.className), !!(leftIconProps !== null && leftIconProps !== void 0 && leftIconProps.className))),
    disabled: disabled,
    error: error,
    icon: leftIcon,
    look: look,
    type: TextfieldIconTypes.Left
  })), /*#__PURE__*/React.createElement(BaseCombobox, {
    "aria-activedescendant": isExpanded && hasSelectedIndex ? (_listboxOptions$selec = listboxOptions[selectedIndex]) === null || _listboxOptions$selec === void 0 ? void 0 : _listboxOptions$selec.key.toString() : undefined,
    "aria-controls": listboxId,
    "aria-describedby": hasError ? alertId : hasHelpText ? helpId : undefined,
    "aria-expanded": isExpanded,
    "aria-invalid": hasError,
    "aria-labelledby": error ? alertId : labId,
    className: classnames({
      'bf-combobox__combobox': true,
      'bf-combobox__combobox--focused': focused,
      'bf-combobox__combobox--hovered': hovered,
      'bf-combobox__combobox--placeholder': !editable && !!(selectedOption !== null && selectedOption !== void 0 && selectedOption.placeholder)
    }),
    disabled: disabled || loadingDisabled,
    divProps: _objectSpread(_objectSpread({}, comboboxDivProps), {}, {
      children: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.placeholder) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.children) || null,
      onBlur: function onBlur(e) {
        setFocused(false);
        if (comboboxDivProps !== null && comboboxDivProps !== void 0 && comboboxDivProps.onBlur) {
          comboboxDivProps.onBlur(e);
        }
      },
      onClick: function onClick(e) {
        focusCombobox();
        toggleExpand();
        if (comboboxDivProps !== null && comboboxDivProps !== void 0 && comboboxDivProps.onClick) {
          comboboxDivProps.onClick(e);
        }
      },
      onFocus: function onFocus(e) {
        setFocused(true);
        if (comboboxDivProps !== null && comboboxDivProps !== void 0 && comboboxDivProps.onFocus) {
          comboboxDivProps.onFocus(e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        var key = e.key;
        if (key === 'ArrowDown') {
          if (!isExpanded) {
            /**
            * Opens the listbox if it is not already displayed without moving focus or changing selection.
            * DOM focus remains on the combobox.
            */
            toggleExpand(true);
          } else if (hasSelectedIndex) {
            /**
            * Moves visual focus to the next option. If visual focus is on the last option, visual focus does not move.
            */
            setSelectedIndex(getNextOption(selectedIndex));
          }
        }
        if (key === 'ArrowUp') {
          if (!isExpanded) {
            /**
            * First opens the listbox if it is not already displayed and then moves visual focus to the first option.
            * DOM focus remains on the combobox.
            */
            setSelectedIndex(getFirstOption());
            toggleExpand(true);
          } else if (hasSelectedIndex) {
            /**
            * Moves visual focus to the previous option.
            * If visual focus is on the first option, visual focus does not move.
            */
            setSelectedIndex(getPreviousOption(selectedIndex));
          }
        }
        if (key === 'Tab') {
          /**
          * Sets the value to the content of the focused option in the listbox.
          * Closes the listbox.
          * Performs the default action, moving focus to the next focusable element.
          */
          onSelected(selectedIndex);
          toggleExpand(false);
        }
        if (comboboxDivProps !== null && comboboxDivProps !== void 0 && comboboxDivProps.onKeyDown) {
          comboboxDivProps.onKeyDown(e);
        }
      },
      onKeyUp: function onKeyUp(e) {
        var key = e.key;
        if (key === 'End') {
          if (!isExpanded) {
            /**
            * Opens the listbox and moves visual focus to the last option.
            */
            toggleExpand(true);
          }
          /**
          * Moves visual focus to the last option.
          */
          setSelectedIndex(getLastOption());
        }
        if (key === 'Home') {
          /**
          * Opens the listbox and moves visual focus to the first option.
          */
          if (!isExpanded) {
            toggleExpand(true);
          }
          setSelectedIndex(getFirstOption());
        }
        if (key === 'Enter' || key === ' ' || key === 'Space') {
          if (isExpanded) {
            /**
            * Sets the value to the content of the focused option in the listbox.
            * Closes the listbox.
            * Sets visual focus on the combobox.
            */
            onSelected(selectedIndex);
          } else {
            /**
            * Opens the listbox without moving focus or changing selection.
            */
            toggleExpand(true);
          }
        }
        if (key === 'Escape') {
          /**
          * Closes the listbox. Sets visual focus on the combobox.
          */
          focusCombobox();
          toggleExpand(false);
        }
        /**
         * Matches a single unicode character
         */
        if (/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])$/.test(key)) {
          setValue(value + key);
        }
        /**
         * There is no `e.target.value`, so we need to handle this ourselves
         */
        if (key === 'Backspace' && value) {
          setValue(value.slice(0, -1));
        }
        if (comboboxDivProps !== null && comboboxDivProps !== void 0 && comboboxDivProps.onKeyUp) {
          comboboxDivProps.onKeyUp(e);
        }
      },
      ref: mergeRefs([comboboxDivProps === null || comboboxDivProps === void 0 ? void 0 : comboboxDivProps.ref, divRef])
    }),
    editable: editable,
    id: comboboxId,
    readOnly: readOnly,
    required: hasRequired,
    textareaProps: _objectSpread(_objectSpread({}, comboboxTextareaProps), {}, {
      'aria-autocomplete': 'list',
      onBlur: function onBlur(e) {
        setFocused(false);
        if (comboboxTextareaProps !== null && comboboxTextareaProps !== void 0 && comboboxTextareaProps.onBlur) {
          comboboxTextareaProps.onBlur(e);
        }
      },
      onChange: function onChange(e) {
        setTouched(true);
        /**
         * Types the character in the textbox.
         * Options in the listbox are filtered based on characters in the textbox.
         */
        setValue(e.target.value);
        if (comboboxTextareaProps !== null && comboboxTextareaProps !== void 0 && comboboxTextareaProps.onChange) {
          comboboxTextareaProps.onChange(e);
        }
      },
      onClick: function onClick(e) {
        if (hasListboxOptions) {
          toggleExpand();
        }
        if (comboboxTextareaProps !== null && comboboxTextareaProps !== void 0 && comboboxTextareaProps.onClick) {
          comboboxTextareaProps.onClick(e);
        }
      },
      onFocus: function onFocus(e) {
        setFocused(true);
        if (comboboxTextareaProps !== null && comboboxTextareaProps !== void 0 && comboboxTextareaProps.onFocus) {
          comboboxTextareaProps.onFocus(e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        var key = e.key;
        if (key === 'ArrowDown') {
          if (!isExpanded && (search || hasFetchedOptions)) {
            /**
            * If the textbox is empty and the listbox is not displayed, opens the listbox and moves visual focus to the first option.
            */
            toggleExpand(true);
            setSelectedIndex(getFirstOption());
          } else if (isExpanded && !hasSelectedIndex) {
            /**
            * If the textbox is not empty and the listbox is displayed, moves visual focus to the first suggested value.
            */
            setSelectedIndex(getFirstOption());
          } else if (hasSelectedIndex) {
            /**
            * Moves visual focus to the next option.
            *
            * If visual focus is on the last option, moves visual focus to the first option.
            */
            setSelectedIndex(getNextOption(selectedIndex));
          }
        }
        if (key === 'ArrowUp') {
          if (!isExpanded && (search || hasFetchedOptions)) {
            /**
            * If the textbox is empty, first opens the listbox if it is not already displayed and then moves visual focus to the last option.
            */
            toggleExpand(true);
            setSelectedIndex(getLastOption());
          } else if (isExpanded && !hasSelectedIndex) {
            /**
            * If the textbox is not empty and the listbox is displayed, moves visual focus to the last suggested value.
            */
            setSelectedIndex(getLastOption());
          } else if (hasSelectedIndex) {
            /**
            * Moves visual focus to the previous option.
            *
            * If visual focus is on the first option, moves visual focus to the last option.
            */
            setSelectedIndex(getPreviousOption(selectedIndex));
          }
        }
        if (key === 'Enter') {
          // prevents parent <form> from submitting when Enter key is pressed
          // (both creating a custom option and selecting a role="option")
          e.preventDefault();
        }
        if (key === 'Tab') {
          toggleExpand(false);
        }
        if (comboboxTextareaProps !== null && comboboxTextareaProps !== void 0 && comboboxTextareaProps.onKeyDown) {
          comboboxTextareaProps.onKeyDown(e);
        }
      },
      onKeyUp: function onKeyUp(e) {
        var key = e.key;
        if (key === 'End') {
          /**
          * Moves visual focus to the textbox and places the editing cursor at the end of the field.
          */
          focusCombobox();
          moveInputCursor('end');
        }
        if (key === 'Home') {
          /**
          * Moves visual focus to the textbox and places the editing cursor at the beginning of the field.
          */
          focusCombobox();
          moveInputCursor('start');
        }
        if (key === 'Enter') {
          if (hasCustomEditable && !hasSelectedIndex) {
            onManualSelection();
          } else if (!isExpanded && (search || hasFetchedOptions)) {
            /**
            * Opens the listbox without moving focus or changing selection.
            */
            toggleExpand(true);
          } else if (hasSelectedIndex) {
            /**
            * Sets the textbox value to the content of the focused option in the listbox.
            * Closes the listbox.
            * Sets visual focus on the textbox.
            */
            onSelected(selectedIndex);
          } else {
            /**
            * Closes the listbox if it is displayed.
            */
            toggleExpand(false);
          }
        }
        if (key === 'Escape') {
          if (isExpanded) {
            /**
            * Closes the listbox. Sets visual focus on the textbox.
            */
            focusCombobox();
            toggleExpand(false);
          } else {
            /**
            * If the listbox is not displayed, clears the textbox.
            */
            setTouched(false);
            setValue('');
          }
        }
        if (comboboxTextareaProps !== null && comboboxTextareaProps !== void 0 && comboboxTextareaProps.onKeyUp) {
          comboboxTextareaProps.onKeyUp(e);
        }
      },
      placeholder: (comboboxTextareaProps === null || comboboxTextareaProps === void 0 ? void 0 : comboboxTextareaProps.placeholder) || ((_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.placeholder),
      ref: mergeRefs([comboboxTextareaProps === null || comboboxTextareaProps === void 0 ? void 0 : comboboxTextareaProps.ref, textareaRef]),
      value: value
    })
  }), /*#__PURE__*/React.createElement(IconButton, _extends({}, iconButtonProps, {
    "aria-controls": listboxId,
    "aria-expanded": isExpanded,
    disabled: disabled || isLoading || readOnly,
    icon: isExpanded && !disabled && !isLoading ? FontIcons.CaretUp : FontIcons.CaretDown,
    label: iconButtonLabel,
    loaderLabel: loaderLabel,
    loading: isLoading,
    look: ButtonLooks.Default,
    onClick: function onClick() {
      focusCombobox();
      toggleExpand();
    },
    showIconButton: showIconButton,
    tabIndex: -1
  })), renderLayer( /*#__PURE__*/React.createElement(Transition, {
    appear: isExpanded,
    in: isExpanded,
    mountOnEnter: true,
    nodeRef: nodeRef,
    timeout: timeout,
    unmountOnExit: true
  }, function (transitionStatus) {
    return /*#__PURE__*/React.createElement(StandardListbox, _extends({}, listboxProps, otherLayerProps, {
      "aria-label": listboxLabel,
      "aria-labelledby": labId,
      ellipsis: ellipsis,
      id: listboxId,
      initialSelectedIndex: initialSelectedIndex,
      keyset: editable ? Keysets.ComboboxInput : Keysets.ComboboxDiv,
      onSelected: onSelected,
      options: hasLoadingOption && isLoading ? [{
        children: loaderLabel,
        disabled: true,
        key: generateKey(),
        value: ''
      }] : hasEmptyOption ? [{
        children: emptyLabel,
        disabled: true,
        key: generateKey(),
        value: ''
      }] : listboxOptions,
      optionProps: optionProps,
      ref: mergeRefs([nodeRef, ref]),
      selectedIndex: selectedIndex,
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.style), !prefersReducedMotion && transition === Transitions.FadeIn && transitionDuration > 0 && transitionFadeIn({
        transitionDelay: delay,
        transitionDuration: duration,
        transitionStatus: transitionStatus
      })), !prefersReducedMotion && transition === Transitions.FadeInSlide && transitionDuration > 0 && transitionFadeInSlide({
        layerSide: layerSide,
        transitionDelay: delay,
        transitionDuration: duration,
        transitionStatus: transitionStatus
      })), parentScrolls && style),
      virtualized: virtualized
    }));
  })))));
};
var Combobox = styled(BaseStandardCombobox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bf-combobox__combobox {\n    ", "\n    ", "\n    ", "\n    ", "\n    align-items: center;\n    cursor: ", ";\n    display: inline-flex;\n    overflow: hidden; // firefox\n    resize: none;\n\n    &.bf-combobox__combobox--hovered {\n      ", "\n    }\n\n    &.bf-combobox__combobox--focused {\n      ", "\n    }\n\n    &.bf-combobox__combobox--placeholder {\n      ", "\n    }\n  }\n\n  .bf-button__icon {\n    border-radius: ", "px;\n    height: 40px;\n    min-height: 0;\n    padding: 5px;\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    width: 40px;\n    z-index: 1;\n\n    [dir='rtl'] & {\n      left: 5px;\n      right: unset;\n    }\n\n    .bf-button__font-icon {\n      font-size: 12px;\n    }\n  }\n\n  .bf-listbox__standard {\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n  }\n\n  &.bf-combobox__standard--position-bottom {\n    .bf-combobox__body {\n      &:after {\n        content: ' ';\n        display: block;\n        height: 5px;\n        width: 100%;\n        position: absolute;\n        top: 100%;\n      }\n    }\n\n    .bf-listbox__standard {\n      top: calc(100% + 5px);\n    }\n  }\n\n  &.bf-combobox__standard--position-top {\n    .bf-combobox__body {\n      &:before {\n        content: ' ';\n        display: block;\n        height: 5px;\n        width: 100%;\n        position: absolute;\n        bottom: 100%;\n      }\n    }\n\n    .bf-listbox__standard {\n      bottom: calc(100% + 5px);\n    }\n  }\n\n  &.bf-combobox__standard--empty,\n  &.bf-combobox__standard--loading {\n    .bf-option__standard--disabled {\n      color: ", ";\n      text-align: center;\n    }\n  }\n"])), baseInputStyle, function (_ref) {
  var after = _ref.after,
    before = _ref.before;
  return getInputBorderRadius({
    after: after,
    before: before
  });
}, function (_ref2) {
  var leftIcon = _ref2.leftIcon;
  return getInputPadding({
    combobox: true,
    leftIcon: leftIcon
  });
}, function (_ref3) {
  var error = _ref3.error,
    look = _ref3.look;
  return getInputTheme({
    error: error,
    look: look
  });
}, function (_ref4) {
  var disabled = _ref4.disabled,
    readOnly = _ref4.readOnly;
  return !disabled && !readOnly ? 'pointer' : 'default';
}, function (_ref5) {
  var disabled = _ref5.disabled,
    error = _ref5.error,
    labels = _ref5.labels,
    loading = _ref5.loading,
    look = _ref5.look;
  return getInputHoveredBorderColor({
    disabled: disabled,
    error: error,
    loading: loading === true && !!labels.loaderLabel,
    look: look
  });
}, function (_ref6) {
  var disabled = _ref6.disabled,
    error = _ref6.error,
    labels = _ref6.labels,
    loading = _ref6.loading,
    look = _ref6.look;
  return getInputFocusedBorderColor({
    disabled: disabled,
    error: error,
    loading: loading === true && !!labels.loaderLabel,
    look: look
  });
}, function (_ref7) {
  var disabled = _ref7.disabled,
    error = _ref7.error,
    labels = _ref7.labels,
    loading = _ref7.loading,
    look = _ref7.look;
  return getInputPlaceholderColor({
    disabled: disabled,
    error: error,
    loading: loading === true && !!labels.loaderLabel,
    look: look
  });
}, borderRadiusLarge, BrandfolderHexColors.Text);
/**
 * A `role="combobox"` with `role="listbox"` that contains `role="option"` elements.
 * `id` and `labels` props are required for accessibility. `onSelection` and `options` props are also required for functionality.
 *
 * When `editable` is `false`, this component re-creates the HTML `<select>` and `<option>` elements
 * with a `<div role="combobox">` that has more flexibility in styling and in rendering content.
 * It follows the W3C select-only combobox [example](https://w3c.github.io/aria-practices/examples/combobox/combobox-select-only.html).
 *
 * When `editable` is `true`, this component creates a searchable `role="listbox"` with `<input role="combobox">`.
 * It follows the W3C editable combobox with list autocomplete [example](https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-list.html).
 *
 * Add a placeholder by providing a first `option` with `option.placeholder = true`.
 * You may hide selecting this placeholder option with `showPlaceholderOption` set to `false`.
 *
 * When `InputLabelPositions.Left`is set, apply a `width` or `max-width` on `.bf-textfield__header`.
 * See Textfield [examples](https://brandfolder.com/designsystem/?path=/docs/components-molecules-textfields--examples)
 * for recommended CSS styling.
 *
 * https://www.w3.org/TR/wai-aria-1.2/#combobox
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/combobox_role
 *
 * @param props StandardComboboxProps
 * @returns FunctionComponent<StandardComboboxProps>
 */
var StandardCombobox = function StandardCombobox(props) {
  var _props$allowCustomVal = props.allowCustomValue,
    allowCustomValue = _props$allowCustomVal === void 0 ? false : _props$allowCustomVal,
    _props$allowOptionsWr = props.allowOptionsWrapping,
    allowOptionsWrapping = _props$allowOptionsWr === void 0 ? true : _props$allowOptionsWr,
    _props$clearAfterCust = props.clearAfterCustomValue,
    clearAfterCustomValue = _props$clearAfterCust === void 0 ? false : _props$clearAfterCust,
    _props$closeOnClickAw = props.closeOnClickAway,
    closeOnClickAway = _props$closeOnClickAw === void 0 ? true : _props$closeOnClickAw,
    _props$editable = props.editable,
    editable = _props$editable === void 0 ? false : _props$editable,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? ComboboxPlacements.BottomStart : _props$placement,
    _props$search = props.search,
    search = _props$search === void 0 ? true : _props$search,
    _props$searchDebounce = props.searchDebounce,
    searchDebounce = _props$searchDebounce === void 0 ? 200 : _props$searchDebounce,
    _props$searchMinLengt = props.searchMinLength,
    searchMinLength = _props$searchMinLengt === void 0 ? 0 : _props$searchMinLengt,
    _props$showEmptyOptio = props.showEmptyOption,
    showEmptyOption = _props$showEmptyOptio === void 0 ? true : _props$showEmptyOptio,
    _props$showIconButton = props.showIconButton,
    showIconButton = _props$showIconButton === void 0 ? true : _props$showIconButton,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    _props$showLoadingOpt = props.showLoadingOption,
    showLoadingOption = _props$showLoadingOpt === void 0 ? true : _props$showLoadingOpt,
    _props$showPlaceholde = props.showPlaceholderOption,
    showPlaceholderOption = _props$showPlaceholde === void 0 ? true : _props$showPlaceholde,
    _props$transition = props.transition,
    transition = _props$transition === void 0 ? Transitions.FadeInSlide : _props$transition,
    _props$transitionDela = props.transitionDelay,
    transitionDelay = _props$transitionDela === void 0 ? 0 : _props$transitionDela,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 200 : _props$transitionDura,
    otherProps = _objectWithoutProperties(props, _excluded3);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Combobox, _extends({}, otherProps, {
    allowCustomValue: allowCustomValue,
    allowOptionsWrapping: allowOptionsWrapping,
    clearAfterCustomValue: clearAfterCustomValue,
    closeOnClickAway: closeOnClickAway,
    editable: editable,
    labelPosition: labelPosition,
    look: look,
    placement: placement,
    search: search,
    searchDebounce: searchDebounce,
    searchMinLength: searchMinLength,
    showEmptyOption: showEmptyOption,
    showIconButton: showIconButton,
    showLabel: showLabel,
    showLoadingOption: showLoadingOption,
    showPlaceholderOption: showPlaceholderOption,
    transition: transition,
    transitionDelay: transitionDelay,
    transitionDuration: transitionDuration
  })));
};
export { BaseStandardCombobox, DEFAULT_EDITABLE_FILTER, DEFAULT_SELECT_FILTER, StandardCombobox };